import './interceptors/refreshToken';
import ThemeProvider from './theme';
import { useEffect } from 'react';
import i18next from 'i18next';
import Router from './routes';
import axios from 'axios';
import './i18n';
import { APP_VERSION, installAppVersionSync } from './utils/appVersionSync';
import { startSessionTrace } from './utils/sessionTrace';
import { AppRuntimeShell } from './components/system/AppRuntimeShell';

axios.defaults.baseURL = window?.env?.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL;

/** @deprecated import from ./utils/appVersionSync */
export const version = APP_VERSION;

export const App = () => {
  useEffect(() => {
    startSessionTrace();
    return installAppVersionSync();
  }, []);

  useEffect(() => {
    axios.defaults.headers.common['Accept-Language'] = 'fr';
    i18next.changeLanguage('fr');
  }, []);

  return (
    <ThemeProvider>
      <AppRuntimeShell>
        <Router />
      </AppRuntimeShell>
    </ThemeProvider>
  );
};
